<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import "./assets/css/reset.min.css"
import "./assets/js/rem"
export default {
    name: 'app',
    data(){
        return {
            
        }
    },
    components: {

    },
    mounted(){
        this.changeSize();
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        window.addEventListener(resizeEvt, this.changeSize);
        
        this.$store.dispatch('getConfig');
    },
    watch: {
        
    },
    methods: {
        changeSize(){
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                this.$store.state.isPhone = true;
            }else{
                this.$store.state.isPhone = false;
            }
        }
    }
}
</script>

<style lang="scss">
#app{
    font-size: 16px;
    font-family: Arial, Helvetica, sans-serif, '宋体', "Microsoft YaHei";
    @media only screen and (max-width: 1024px) {
        font-size: .36rem;
    }
}
.body{
    position: relative;
}
.container{
    position: relative;
    z-index: 1;
    width: 1206px;
    margin: 0 auto;
    @media only screen and (max-width: 1024px) {
        width: 100%;
    }
}
.content_title{
    display: flex;
    align-items: center;
    height: 55px;
    border-bottom: 1px dashed #a5a5a5;
    font-size: 26px;
    color: #2e3a4c;
    padding-left: 50px;
    margin: 10px 0 30px;
    background: url('~@/assets/images/2_13.jpg') no-repeat;
    background-position: left center;
    &::after{
        content: '';
        border-top: 10px solid #4287d2;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        margin-left: 10px;
    }
    @media only screen and (max-width: 1024px) {
        font-size: .36rem;
        font-weight: bold;
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        height: auto;
        margin-bottom: .3rem;
        &::after{
            display: none;
        }
    }
}
@media only screen and (max-width: 1024px) {
    .list_wrap_mobile{
        .content_title{
            border-bottom: 1px solid #e8eaed;
            height: 1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .3rem;
            font-size: .36rem;
            color: #1953b3;
            font-weight: bold;
            margin-bottom: 0;
            &::after{
                content: "";
                width: .5rem;
                height: .5rem;
                background: url('~@/assets/images/001.png') no-repeat center/cover;
            }
        }
    }
}
.loading{
    width: 30px;
    height: 30px;
    margin: 50px auto;
    border: 2px solid #000;
    border-top-color: transparent;
    border-radius: 100%;
    animation: circle infinite 0.75s linear;
    @keyframes circle {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}
.nothing{
    text-align: center;
    color: #999;
    margin: 50px auto;
}
</style>
